import React from 'react';
import { InspireTransferPatient } from '../../models/inspire-transfer-patient';
import { useCookies } from 'react-cookie';
import { FormattedMessage } from 'react-intl';
import { keyStr } from './constants';

const TransferPatientAlert = () => {
    const [cookies, setCookie] = useCookies(['transferPatient']);
    const transferPatient = parseTransferPatient(cookies.transferPatient);
    const clearPatientData = () => {
        if (transferPatient) {
            const expiration = new Date();
            expiration.setDate(expiration.getDate() - 1);
            setCookie('transferPatient', '', {
                expires: expiration,
                path: '/',
            });
        }
    };
    return (
        <>
            {transferPatient && (
                <div className="patient-alert patient-alert-inline">
                    <button
                        className="btn btn-primary pull-right"
                        onClick={clearPatientData}
                    >
                        <FormattedMessage
                            id={'Clear_Patient_Data'}
                            defaultMessage={'Clear Patient Data'}
                        />
                    </button>
                    <span className="alert-header">
                        <FormattedMessage
                            id={'ATTENTION_UPPER'}
                            defaultMessage={'ATTENTION'}
                        />
                        :
                    </span>
                    <FormattedMessage
                        id={'We_have_transferred_patient_data'}
                        defaultMessage={`We have transferred patient data for 
                        ${0}. The data will be cleared as soon as you log out.`}
                        values={{
                            0: (
                                <strong>
                                    {transferPatient.firstName}{' '}
                                    {transferPatient.lastName}
                                </strong>
                            ),
                        }}
                    />
                </div>
            )}
        </>
    );
};

export const parseTransferPatient = (
    transferPatientCookie: string | undefined
): InspireTransferPatient | undefined => {
    return transferPatientCookie
        ? JSON.parse(
              decodeBase64String(transferPatientCookie)
                  .replace(/"mcl":/g, '"MCL":')
                  .replace(/"ucl":/g, '"UCL":')
          )
        : undefined;
};

const decodeBase64String = (input: string) => {
    let t = '';
    let n, r, i;
    let s, o, u, a;
    let f = 0;
    input = input.replace(/[^A-Za-z0-9+/=]/g, '');
    while (f < input.length) {
        s = keyStr.indexOf(input.charAt(f++));
        o = keyStr.indexOf(input.charAt(f++));
        u = keyStr.indexOf(input.charAt(f++));
        a = keyStr.indexOf(input.charAt(f++));
        n = (s << 2) | (o >> 4);
        r = ((o & 15) << 4) | (u >> 2);
        i = ((u & 3) << 6) | a;
        t = t + String.fromCharCode(n);
        if (u !== 64) {
            t = t + String.fromCharCode(r);
        }
        if (a !== 64) {
            t = t + String.fromCharCode(i);
        }
    }

    t = decodeURIComponent(escape(t));

    return t;
};

export default TransferPatientAlert;
